import ImgWebp from "../../../assets/images/dream-rate.webp"
import ImgPng from "../../../assets/images/dream-rate.png"
import PopUpNotification from "../pop-up-notification"
import { ENGAGE_LINK } from "../../constants"

const NewsPopup = () => (
  <PopUpNotification id="dream-rate">
    <div className="relative text-center pt-3 bg-[#00000E]">
      <div className="absolute top-[53px] -left-6 transform -rotate-45 origin-top-left">
        <div className="bg-violet-500 text-white text-sm h-[22px] w-28 leading-[22px] font-medium">
          <span className="relative left-[-2px]">NEW</span>
        </div>
      </div>

      <picture>
        <source srcSet={ImgWebp} type="image/webp" />
        <img
          className="w-[297px] inline-block mb-[-14px]"
          src={ImgPng}
          alt="Chat screenshot"
        />
      </picture>
    </div>

    <h2 className="text-xl font-serif font-semibold text-base-dark m-0 pt-3 px-6">
      Never Miss A Refi.
    </h2>
    <p className="text-sm text-base-dark m-0 pt-1 px-6 pb-3">
      Set Target Rate. Automate Outreach.
      <a
        className="inline-block mt-3 text-primary-400 hover:text-primary-500 border-b border-dashed border-primary-400 hover:border-primary-500 pb-px"
        target="_blank"
        href={ENGAGE_LINK}
      >
        Learn more
      </a>
    </p>
  </PopUpNotification>
)

export default NewsPopup
